import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../img/active_arrow.svg'
import _imports_1 from '../img/arrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-d2c12e0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "addImg" }, null, -1))
const _hoisted_3 = { class: "addText" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "addImg" }, null, -1))
const _hoisted_5 = { class: "addText" }
const _hoisted_6 = { class: "device-style single-style" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "model" }
const _hoisted_10 = { class: "item-style single-item overflow" }
const _hoisted_11 = { class: "small-model small-style overflow" }
const _hoisted_12 = { class: "centerBody" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconSetWidth" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "menuIconDash" })
], -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "front" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "arrow",
  src: _imports_0
}
const _hoisted_18 = {
  key: 1,
  class: "arrow",
  src: _imports_1
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "small-model overflow" }
const _hoisted_22 = {
  key: 0,
  class: "addDevice noaddDevice"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "addImg" }, null, -1))
const _hoisted_24 = { class: "addText" }
const _hoisted_25 = { class: "addDevice" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "addImg" }, null, -1))
const _hoisted_27 = { class: "addText" }
const _hoisted_28 = { class: "centerBody" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconSetWidth" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "menuIconDash" })
], -1))
const _hoisted_30 = { ref: "secondMenu" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "front" }
const _hoisted_33 = ["src"]
const _hoisted_34 = {
  key: 0,
  class: "arrow",
  src: _imports_0
}
const _hoisted_35 = {
  key: 1,
  class: "arrow",
  src: _imports_1
}
const _hoisted_36 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_nav = _resolveComponent("my-nav")!
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return ((_ctx.subscripts.begins_at && _ctx.deviceInfo.length > 0) ||
    (_ctx.subscripts.begins_at && !_ctx.expired && _ctx.deviceInfo.length == 0) ||
    (_ctx.subscripts.begins_at && _ctx.expired && _ctx.deviceInfo.length > 0)
    )
    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.menuList, (v) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: v.name ? v.name : 'single'
        }, [
          (v.children && v.children.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(), _createBlock(_component_el_sub_menu, {
                  index: v.name,
                  key: v.name,
                  class: "theme-bg",
                  style: {"overflow-y":"auto","max-height":"700px"}
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("img", {
                      src: v.meta.icon,
                      class: "img-style"
                    }, null, 8, _hoisted_1),
                    _createElementVNode("span", {
                      class: _normalizeClass(v.meta.isDevice ? 'title-style' : 'theme-color')
                    }, _toDisplayString(_ctx.$t(v.meta.name)), 3)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item_group, { class: "ulStyle" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_my_nav, {
                          menuList: v.children
                        }, null, 8, ["menuList"])
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", {
                      class: "addDevice",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoPay()))
                    }, [
                      _hoisted_2,
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("leftTab.toBuy")), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["index"])),
                (_ctx.state.singleDeviceShow)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!_ctx.haveExpiresTime || _ctx.clickGoPay)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"width":"100%"},
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openMenu && _ctx.openMenu(...args)))
                          }, [
                            _createElementVNode("div", {
                              class: "addDevice",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.singlegotoPay()))
                            }, [
                              _hoisted_4,
                              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("leftTab.toBuy")), 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: {"width":"100%"},
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openMenu && _ctx.openMenu(...args)))
                          }, [
                            _createElementVNode("div", _hoisted_6, [
                              (_ctx.showUnbound)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.deviceType ? _ctx.grayIphone : _ctx.unLauncher,
                                    class: "img-style",
                                    style: {"padding-left":"10px !important"}
                                  }, null, 8, _hoisted_7))
                                : (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: _ctx.deviceType ? _ctx.iphone : _ctx.Launcher,
                                    class: "img-style",
                                    style: {"padding-left":"10px !important"}
                                  }, null, 8, _hoisted_8)),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("span", _hoisted_10, _toDisplayString(!_ctx.currentDeviceInfo.last_update_at
                ? _ctx.$t(_ctx.currentDeviceInfo.name)
                : (_ctx.deviceType
                  ? _ctx.currentAppleId
                  : _ctx.currentDeviceInfo.name)), 1),
                                _createElementVNode("span", _hoisted_11, _toDisplayString(!_ctx.currentDeviceInfo.last_update_at
                ? _ctx.$t(_ctx.currentDeviceInfo.model)
                : (_ctx.deviceType
                  ? (_ctx.currentDeviceInfo.name ? _ctx.currentDeviceInfo.name : '--')
                  : _ctx.currentDeviceInfo.model)), 1)
                              ])
                            ])
                          ]))
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["menu", _ctx.lang == 'ar' ? 'reverse' : ''])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["dashboard itemMenu", { active: _ctx.defaultMenu === 'home' }]),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.gotoMyRoute('home')))
                    }, [
                      _hoisted_13,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("leftTab.dashboard")), 1)
                    ], 2)
                  ], 2)
                ]),
                _createElementVNode("div", {
                  ref_for: true,
                  ref: "secondMenu",
                  style: {"width":"256px"}
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterMenu, (item, fIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["secondMenuSub", _ctx.lang == 'ar' ? 'reverse' : '']),
                      key: item.id
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["secondMenuHeader", { activeStyle: item.active }]),
                        onClick: ($event: any) => (_ctx.clickTitle(item, fIndex))
                      }, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("img", {
                            class: _normalizeClass(["fontSet", { active: item.active }]),
                            src: item.active ? item.activeIcon : item.icon
                          }, null, 10, _hoisted_16),
                          _createElementVNode("div", null, _toDisplayString(_ctx.$t(item.className)), 1)
                        ]),
                        (item.active)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                          : (_openBlock(), _createElementBlock("img", _hoisted_18))
                      ], 10, _hoisted_14),
                      (item.active)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.children, (ele, sIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "secondMenuContent",
                              key: ele.id,
                              onClick: ($event: any) => (_ctx.clickSub(item, ele, fIndex, sIndex))
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass({ activeSonStyle: ele.active && item.active })
                              }, _toDisplayString(_ctx.$t(ele.className)), 3)
                            ], 8, _hoisted_19))
                          }), 128))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ], 512)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.state.subscripts.begins_at !== '')
                  ? (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: v.name,
                      index: v.name,
                      onClick: ($event: any) => (_ctx.gotoRoute(v.path, v.meta)),
                      class: _normalizeClass(["device-style", _ctx.pickId == v.meta.id ? 'pick-item' : ''])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: v.meta.icon,
                          class: "img-style"
                        }, null, 8, _hoisted_20),
                        _createElementVNode("div", {
                          class: _normalizeClass(["model", _ctx.lang == 'ar' ? 'reverse1' : ''])
                        }, [
                          _createElementVNode("span", {
                            class: "overflow item-style",
                            style: _normalizeStyle({ marginLeft: _ctx.isSidebarNavCollapse ? '10px' : '0' })
                          }, [
                            _createVNode(_component_Tooltip, {
                              content: v.meta.isEmpty ? _ctx.$t(v.meta.name) : v.meta.name
                            }, null, 8, ["content"])
                          ], 4),
                          _createElementVNode("span", _hoisted_21, [
                            _createVNode(_component_Tooltip, {
                              content: v.meta.isEmpty ? _ctx.$t(v.meta.model) : v.meta.model
                            }, null, 8, ["content"])
                          ])
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["index", "onClick", "class"]))
                  : _createCommentVNode("", true)
              ], 64))
        ], 64))
      }), 128))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createVNode(_component_el_menu, {
          onOpen: _ctx.menuOpened,
          onClose: _ctx.menuClosed,
          ref: "noMenuRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_sub_menu, { index: "Device" }, {
              title: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("leftTab.device")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.noGotoPay())),
                  style: {"min-height":"80px"}
                }, {
                  default: _withCtx(() => [
                    (!_ctx.state.singleDeviceShow)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("leftTab.toBuy")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.state.singleDeviceShow)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: {"width":"100%","min-height":"80px"},
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.noSinglePay()))
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("leftTab.toBuy")), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onOpen", "onClose"]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", {
            class: _normalizeClass(["menu", _ctx.lang == 'ar' ? 'reverse' : ''])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["dashboard itemMenu", { active: _ctx.defaultMenu === 'home' }]),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.gotoMyRoute('home')))
            }, [
              _hoisted_29,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("leftTab.dashboard")), 1)
            ], 2)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_30, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterMenu, (item, fIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "secondMenuSub",
              key: item.id
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["secondMenuHeader", { activeStyle: item.active }]),
                onClick: ($event: any) => (_ctx.clickTitle(item, fIndex))
              }, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("img", {
                    class: _normalizeClass(["fontSet", { active: item.active }]),
                    src: item.active ? item.activeIcon : item.icon
                  }, null, 10, _hoisted_33),
                  _createElementVNode("div", null, _toDisplayString(item.className), 1)
                ]),
                (item.active)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_34))
                  : (_openBlock(), _createElementBlock("img", _hoisted_35))
              ], 10, _hoisted_31),
              (item.active)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.children, (ele, sIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "secondMenuContent",
                      key: ele.id,
                      onClick: ($event: any) => (_ctx.clickSub(item, ele, fIndex, sIndex))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass({ activeSonStyle: ele.active && item.active })
                      }, _toDisplayString(ele.className), 3)
                    ], 8, _hoisted_36))
                  }), 128))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ], 512)
      ], 64))
}